import { Grid, GridColumn, Separator } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ITranslateStore } from '../../../stores/TranslateStore';
import BoxNotice from '../../common/BoxNotice';
import PrepaymentButton from '../PrepaymentButton';
import TotalPrepaymentAmount from '../TotalPrepaymentAmount';
import UnsettledReceivablesStore from '../../../stores/UnsettledReceivablesStore';

interface IAllPaidNotice {
  unsettledReceivablesStore?: UnsettledReceivablesStore;
  translateStore?: ITranslateStore;
}

@inject('unsettledReceivablesStore', 'translateStore')
@observer
export default class AllPaidNotice extends React.Component<IAllPaidNotice> {
  public render(): JSX.Element {
    return (
      <React.Fragment>
        <Separator spacing="small" color="invisible" />
        <BoxNotice type="success">
          <Grid align={['between-xs', 'middle-xs']}>
            <GridColumn width={['xs']}>
              {this.getAllPaidText()}
              {this.getGenerationPeriodText()}
            </GridColumn>
            <GridColumn width={['xs']}>
              <Grid>
                <GridColumn width={['xs']}>
                  <PrepaymentButton style="notice" />
                </GridColumn>
              </Grid>
            </GridColumn>
          </Grid>
        </BoxNotice>
      </React.Fragment>
    );
  }

  private getAllPaidText() {
    const translate = this.props.translateStore.translate;
    const hasPrepayments = this.props.unsettledReceivablesStore.hasPrepayments;

    if (!hasPrepayments) {
      return translate('invoices.notices.all-paid.without-prepayment');
    } else {
      return (
        <React.Fragment>
          {translate('invoices.notices.all-paid.with-prepayment')}{' '}
          <span className="c-brand-primary-text text-bold">
            <TotalPrepaymentAmount />
          </span>
          {'.'}
        </React.Fragment>
      );
    }
  }

  private getGenerationPeriodText() {
    const translate = this.props.translateStore.translate;
    const isInvoiceGenerationPeriod = this.props.unsettledReceivablesStore.isInvoiceGenerationPeriod;

    if (isInvoiceGenerationPeriod) {
      return ` ${translate('invoices.notices.all-paid.invoice-generation-period')}`;
    }
    return '';
  }
}
